import React from 'react'
import agent from '../agent'
import TradingPairList from './widgets/TradingPairList'
import AccountList from './widgets/AccountList'
import CodeList from './widgets/CodeList'
import PresaleList from './widgets/PresaleList'
import Loading from './widgets/Loading'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import ListErrors from './ListErrors';
import CategoryListLink from './widgets/CategoryListLink';
import ProductListLink from './widgets/ProductListLink';
import {
  USER_PAGE_LOADED,
  USER_PAGE_UNLOADED,
  UPDATE_LOCK_STATUS,
  RESET_BANK_VERIFICATION,
  USER_ROLE_UPDATED,
  USER_TOGGLE_MFA,
  USER_TASK_LIST_LOADED,
  ACCOUNT_PAGE_LOADED,
  USER_REFERRER_UPDATED,
  RESEND_VERIFICATION_EMAIL,
  UPDATE_PHONE_STATUS,
  UPDATE_MERCHANT_FEE_RATE,
  UPDATE_PHONE,
  RESET_TOTP,
  UPDATE_PIN
} from '../constants/actionTypes'
import { BASE_COIN_SYMBOL, AVATAR_BASEURL } from '../constants/config'
import role from '../util/role'

const Promise = global.Promise;

const mapStateToProps = state => ({
  ...state.user,
  currentUser: state.common.currentUser,
  inProgress: state.common.inProgress
});

const mapDispatchToProps = dispatch => ({
  onLoad: payload =>
    dispatch({ type: USER_PAGE_LOADED, payload }),
  onUnload: () =>
    dispatch({ type: USER_PAGE_UNLOADED }),
  onUpdateLockStatus: (key, locked) => {
    const payload = agent.Users.updateLockStatus(key, locked)
    dispatch({ type: UPDATE_LOCK_STATUS, payload })
  },
  onResetBankVerification: (key) => {
    const payload = agent.Users.resetBankVerification(key)
    dispatch({ type: RESET_BANK_VERIFICATION, payload })
  },
  onUpdateRole: (payload) => {
    dispatch({ type: USER_ROLE_UPDATED, payload })
  },
  onToggleMFA: (payload) => {
    dispatch({ type: USER_TOGGLE_MFA, payload })
  },
  onUpdateReferrer: (payload) => {
    dispatch({ type: USER_REFERRER_UPDATED, payload })
  },
  onResendVerificationEmail: (payload) => {
    dispatch({ type: RESEND_VERIFICATION_EMAIL, payload })
  },
  onUpdatePhoneStatus: (key, verified) => {
    const payload = agent.Users.updatePhoneStatus(key, verified)
    dispatch({ type: UPDATE_PHONE_STATUS, payload })
  },
  onUpdateMerchantFeeRate: (payload) => {
    dispatch({ type: UPDATE_MERCHANT_FEE_RATE, payload })
  },
  onResetTotp: (key) => {
    const payload = agent.Users.resetTotp(key)
    dispatch({ type: RESET_TOTP, payload })
  },
  onUpdatePhone: (payload) => {
    dispatch({ type: UPDATE_PHONE, payload })
  },
  onUpdatePin: (payload) => {
    dispatch({ type: UPDATE_PIN, payload })
  },
});

class Avatar extends React.Component {
  render() {
    if (this.props.url) {
      return (
        <div className="infoPair">
          <label>Avatar:</label> <span><img className="inlineAvatar" src={AVATAR_BASEURL + this.props.url} alt="avatar" /></span>
        </div>
      )
    }
    return null
  }
}



class UserDetail extends React.Component {
  constructor() {
    super()
    this.state = {
      referrer: '',
      pin: ''
    }
    this.updateState = field => ev => {
      const state = this.state;
      const newState = Object.assign({}, state, { [field]: ev.target.value });
      this.setState(newState);
    };
    this.updateUserStatus = (key, locked) => ev => {
      ev.preventDefault()
      this.props.onUpdateLockStatus(key, locked)
    }
    this.resetBankVerification = (key) => ev => {
      ev.preventDefault()
      this.props.onResetBankVerification(key)
    }
    this.toggleMFA = (key, enabled) => ev => {
      const payload = agent.Users.toggleMFA(key, enabled)
      this.props.onToggleMFA(payload)
    }
    this.updateRole = (key, role) => ev => {
      const payload = agent.Users.updateRole(key, role)
      this.props.onUpdateRole(payload)
    }
    this.updateReferrer = (key, referrer) => ev => {
      const payload = agent.Users.updateReferrer(key, referrer)
      this.props.onUpdateReferrer(payload)
    }
    this.resendVerificationEmail = (key) => ev => {
      const payload = agent.Users.resendVerificationEmail(key)
      this.props.onResendVerificationEmail(payload)
    }
    this.updatePhoneStatus = (key, verified) => ev => {
      ev.preventDefault()
      this.props.onUpdatePhoneStatus(key, verified)
    }
    this.updateMerchantFeeRate = (key, merchant_fee_rate) => ev => {
      ev.preventDefault()
      const payload = agent.Users.updateMerchantFeeRate(key, merchant_fee_rate / 100)
      this.props.onUpdateMerchantFeeRate(payload)
    }
    this.resetTotp = (key) => ev => {
      ev.preventDefault()
      if (window.confirm('Are you sure you want to reset this user\'s TOTP? This action cannot be recovered. After reset the user will need to use SMS as their two factor authentication method.')) {
        this.props.onResetTotp(key)
      }
    }
    this.updatePhone = (key, phone) => ev => {
      ev.preventDefault()
      const payload = agent.Users.updatePhone(key, phone)
      this.props.onUpdatePhone(payload)
    }
    this.updatePin = (key, pin) => ev => {
      ev.preventDefault()
      const payload = agent.Users.updatePin(key, pin)
      this.props.onUpdatePin(payload)
    }
  }

  componentWillMount() {
    this.props.onLoad(Promise.all([
      agent.Users.get(this.props.match.params.key),
      agent.Accounts.user(this.props.match.params.key),
      // agent.Users.getTradeAnalysis(this.props.match.params.key)
    ]));
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.user) {
      Object.assign(this.state, {
        referrer: nextProps.user.referrer || '',
        merchant_fee_rate: nextProps.user.merchant_fee_rate ? nextProps.user.merchant_fee_rate * 100 : '',
        phone: nextProps.user.phone || ''
      })
    }
  }
  componentWillUnmount() {
    this.props.onUnload();
  }

  render() {
    if (!this.props.user) {
      return (
        <Loading />
      )
    }
    const referrer = this.state.referrer
    const mobile_codes = this.props.user.mobile_codes || []
    const user_codes = this.props.user.user_codes || []
    const merchant_fee_rate = this.state.merchant_fee_rate
    const phone = this.state.phone
    const pin = this.state.pin
    return (
      <div className="pane">
        <Link className="crumb" to="/users">&laquo; back to users</Link>

        <h1>{this.props.user.firstname} {this.props.user.lastname}</h1>
        <ListErrors errors={this.props.errors} />
        <div className="infoGroup">
          <div className="infoPair">
            <label>Key:</label> <span>{this.props.user.key}</span>
          </div>
          <div className="infoPair">
            <label>Email:</label> <span>{this.props.user.email}</span>
          </div>
          {role.can(this.props.currentUser.role, UPDATE_PHONE) ?
            <div className="infoPair">
              <label>Phone:</label>
              <span>
                <input
                  className="simplerInput"
                  type="text"
                  placeholder="phone"
                  value={phone}
                  onChange={this.updateState('phone')}
                />
                <button className="buttonActionSmall" onClick={this.updatePhone(this.props.user.key, phone)}>{this.props.update_phone_inprogress ? 'Updating...' : 'Update'} </button>
              </span>
            </div>
            : <div className="infoPair">
              <label>Phone:</label> <span>{this.props.user.phone}</span>
            </div>
          }
          {role.can(this.props.currentUser.role, UPDATE_PIN) ?
            <div className="infoPair">
              <label>New Pin:</label>
              <span>
                <input
                  className="simplerInput"
                  type="password"
                  maxLength={4}
                  placeholder="new pin"
                  value={pin}
                  onChange={this.updateState('pin')}
                />
                <button className="buttonActionSmall" onClick={this.updatePin(this.props.user.key, pin)}>{this.props.update_pin_inprogress ? 'Updating...' : 'Update'} </button>
              </span>
            </div>
            : null
          }

          <div className="infoPair">
            <label>Email Verified:</label> <span>{this.props.user.email_verified === true ? 'Yes' : 'No'}</span>
          </div>
          <div className="infoPair">
            <label>ID Verified:</label> <span>{this.props.user.id_verified === true ? "Yes" : "No"}</span>
          </div>
          <div className="infoPair">
            <label>Address Verified:</label> <span>{this.props.user.address_verified === true ? "Yes" : "No"}</span>
          </div>
          <div className="infoPair">
            <label>Phone verified:</label> <span>{this.props.user.phone_verified === true ? 'Yes' : 'No'}</span>
          </div>
          <div className="infoPair">
            <label>Country:</label> <span>{this.props.user.country}</span>
          </div>

          <div className="infoPair">
            <label>Registered:</label> <span>{this.props.user.created}</span>
          </div>

          {role.can(this.props.currentUser.role, USER_TASK_LIST_LOADED) ?
            <div className="infoPair">
              <label>Tasks:</label> <span><Link to={`/tasks/user/${this.props.user.key}`}>User Task List &raquo;</Link></span>
            </div> : null}

          {role.isMerchant(this.props.user.role) ?
            (
              <div>
                <div className="infoPair">
                  <label>Categories:</label> <span><CategoryListLink userKey={this.props.user.key} currentUser={this.props.currentUser} /></span>
                </div>
                <div className="infoPair">
                  <label>Products:</label> <span><ProductListLink userKey={this.props.user.key} currentUser={this.props.currentUser} /></span>
                </div>
                <div className="infoPair">
                  <label>Merchant Fee Rate:</label>
                  <span>
                    <input
                      type="text"
                      placeholder="Fee Rate"
                      value={merchant_fee_rate}
                      onChange={this.updateState('merchant_fee_rate')}
                    />%
                    <button className="buttonActionSmall" onClick={this.updateMerchantFeeRate(this.props.user.key, merchant_fee_rate)}>{this.props.inProgress ? 'Updating...' : 'Update'} </button>
                  </span>
                </div>
              </div>
            ) : null}
          <div className="infoPair">
            <label>Bank Verification:</label> <span>{this.props.user.bank_verify_task_complete === true ? 'completed' : 'pending'}</span>
          </div>
        </div>
        {
          this.props.user.bank_status ?
            this.props.user.bank_status.status === 'verifying' ?
              <div className="infoGroup">
                <div className="infoPair">
                  <label>Bank Status:</label> <span>{this.props.user.bank_status.status}</span>
                </div>
                <div className="infoPair">
                  <label>Amount 1:</label> <span>{this.props.user.bank_status.amount1}</span>
                </div>
                <div className="infoPair">
                  <label>Amount 2:</label> <span>{this.props.user.bank_status.amount2}</span>
                </div>
                <div className="infoPair">
                  <label>Bank Code:</label> <span>{this.props.user.bank_status.verifyCode}</span>
                </div>
                <div className="infoPair">
                  <label>Verification Count:</label> <span>{this.props.user.bank_verify_count || 0}</span>
                </div>
              </div>
              :
              <div className="infoGroup">
                <div className="infoPair">
                  <label>Bank Status:</label> <span>{this.props.user.bank_status.status}</span>
                </div>
                <div className="infoPair">
                  <label>Verification Count</label> <span>{this.props.user.bank_verify_count || 0}</span>
                </div>
              </div>
            :
            <div className="infoGroup">
              <div className="infoPair">
                <label>Bank status:</label> <span>Not verified </span>
              </div>
            </div>
        }

        <div className="infoGroup">
          {role.can(this.props.currentUser.role, UPDATE_LOCK_STATUS)
            ? <button className="buttonAction" onClick={this.updateUserStatus(this.props.user.key, this.props.user.locked ? false : true)}>{this.props.user.locked ? 'Unlock User' : 'Lock User'}</button>
            : null}
          {role.can(this.props.currentUser.role, UPDATE_PHONE_STATUS)
            ? <button className="buttonAction" onClick={this.updatePhoneStatus(this.props.user.key, this.props.user.phone_verified ? false : true)}>{this.props.user.phone_verified ? 'Mark Phone as Unverified' : 'Mark Phone as Verified'}</button>
            : null}
          {this.props.user.bank_status && role.can(this.props.currentUser.role, RESET_BANK_VERIFICATION) ?
            (
              <button className="buttonAction" onClick={this.resetBankVerification(this.props.user.key)}>Reset Bank Verification</button>
            )
            : null}
          {role.can(this.props.currentUser.role, USER_ROLE_UPDATED) && !role.isMerchant(this.props.user.role)
            ? <button className="buttonAction" onClick={this.updateRole(this.props.user.key, this.props.user.role === 0 ? 999 : 0)}>{this.props.user.role === 0 ? 'Promote to Admin' : 'Demote Admin'}</button>
            : null}
          {(role.can(this.props.currentUser.role, USER_ROLE_UPDATED) && !role.isMerchant(this.props.user.role))
            ? <button className="buttonAction" onClick={this.updateRole(this.props.user.key, 1)}>{'Set as Merchant'}</button>
            : null}
          {/* {role.can(this.props.currentUser.role, USER_TOGGLE_MFA)
            ? <button className="buttonAction" onClick={this.toggleMFA(this.props.user.key, this.props.user.two_FA_enabled ? false : true)}>{this.props.user.two_FA_enabled ? 'Disable MFA' : 'Enable MFA'}</button>
            : null} */}
          {role.can(this.props.currentUser.role, RESEND_VERIFICATION_EMAIL)
            ? <button className="buttonAction" onClick={this.resendVerificationEmail(this.props.user.key)}>{'Resend Verification Email'}</button>
            : null}
          {this.props.user.totp_setup === true && role.can(this.props.currentUser.role, RESET_TOTP)
            ? <button className="buttonAction" onClick={this.resetTotp(this.props.user.key)}>{'Reset TOTP'}</button>
            : null}
        </div>
        {
          this.props.user.presales ?
            <div className="infoGroup">
              <div className="infoAction">
                <h2>Presales</h2>
                <PresaleList presales={this.props.user.presales} loading={this.props.loading} />
              </div>
            </div>
            : null
        }
        <div className="infoGroup">
          <div className="infoAction">
            <h2>Recent codes</h2>
            <CodeList codes={user_codes.concat(mobile_codes)} loading={this.props.loading} />
          </div>
        </div>
        {/* <div className="infoGroup">
          <div className="infoAction">
            <h2>Trade Analysis</h2>
            <TradingPairList tradeAnalysis={this.props.tradeAnalysis} loading={this.props.loading} />
          </div>
        </div> */}
        {role.can(this.props.currentUser.role, ACCOUNT_PAGE_LOADED) ?
          <div className="infoGroup">
            <div className="infoAction">
              <h2>Accounts <span><Link className="buttonTop" to={`/users/${this.props.user.key}/accounts/create`}><i className="icon ion-android-add-circle"></i></Link></span></h2>
              <AccountList accounts={this.props.accounts} loading={this.props.loading} />
            </div>
          </div>
          : null}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserDetail);



// WEBPACK FOOTER //
// ./src/components/UserDetail.js